import type { CSSProperties, HTMLAttributes } from 'react';
import { cn } from './cn';

export type StatusDotTone = 'success' | 'warn' | 'danger' | 'info' | 'neutral' | 'progress';

const TONE_COLOR: Record<StatusDotTone, string> = {
  success: 'var(--signal-success)',
  warn: 'var(--signal-warn)',
  danger: 'var(--signal-danger)',
  info: 'var(--signal-info)',
  neutral: 'var(--content-muted)',
  progress: 'var(--status-progress-fg)',
};

export interface StatusDotProps extends HTMLAttributes<HTMLSpanElement> {
  tone: StatusDotTone;
  label: string;
  outline?: boolean;
}

export const StatusDot = ({ tone, label, outline, className, style, ...rest }: StatusDotProps) => {
  const color = TONE_COLOR[tone];
  const dotStyle: CSSProperties = outline
    ? {
        width: 8,
        height: 8,
        borderRadius: '50%',
        border: `1.5px solid ${color}`,
        background: 'transparent',
        flexShrink: 0,
      }
    : {
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: color,
        flexShrink: 0,
      };

  return (
    <span
      className={cn('inline-flex items-center gap-2 text-[13px]', className)}
      style={{ color: 'var(--content-default)', ...style }}
      {...rest}
    >
      <span style={dotStyle} aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
};
